import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { LoginData } from '../../_models/loginData';
import { User } from '../../_models/user';
import * as CryptoJS from 'crypto-js';
import { beatBlipSubscriptionConsts } from '../../consts/beatBlipSubscriptionConsts';
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/_services/user.service';
import { environment } from "src/environments/environment";
import { EncryptedServiceService } from 'src/app/_services/encrypted-service.service';
import { HomeService } from 'src/app/_services/home.service';
import { BrowserSessionService } from 'src/app/browser-session.service';
declare var $;
@Component({
    selector: "app-login",
    templateUrl: 'userLogin.component.html',
    styleUrls: ['./userLogin.component.css'],
})
export class UserLoginComponent implements OnInit {
 loginForm: UntypedFormGroup;
 forgotPasswordForm: UntypedFormGroup;

 @ViewChild('closemodal', null) closemodal: ElementRef;
 @ViewChild('cancelmodal'  , null) cancelmodal:ElementRef;
     submitted = false;
     submittedForgotPasswordForm = false;
    currentUser: any;
     okta_sso: string;
     azure_sso: string;
    octaEnable: boolean;
    loginData1: any;
    allFlag: any;
    showLogin:any = true;
    showOkta:any = false;
    showAzure:any = false
    isNewUIRedirect: boolean = true;
     constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userService: UserService,
        private cookieService: CookieService,
        @Inject( DOCUMENT ) private document: Document,
        private toastr: ToastrService,
        private encryptedService:EncryptedServiceService,
        private homeService: HomeService,
        _boot: BrowserSessionService
    ) {
        this.okta_sso = environment.okta_sso;
        this.azure_sso = environment.azure_sso;
        this.octaEnable = environment.okta;
    }
    ngOnInit() {

      this.checkLoginFlag();
        var logout = 'false';
        var redirect = 'false';
        var loggedInFromDifferrntBrowser = 'false';
        var updatePassword = 'false';
        var accesTokenExpired = 'false';
        var hash = window.location.hash
        var search = window.location.search;
        let azureUserName = this.activatedRoute.snapshot.queryParams['username'];
        if(search.includes("okta")){
           
            var params = search.split('&type');
            var encodedData = params[0].substring(1);
           // var email= params[2].substring(0,params[2].indexOf('&'));
            var type= params[1].substring(1);
            let returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];

            var encryptedBase64Key = 'bXVzdGJlMTZieXRlc2tleQ==';
            var parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);
            var encryptedCipherText = encodedData.split("%2F").join("/");;
            var decryptedData = CryptoJS.AES.decrypt( encryptedCipherText, parsedBase64Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
            } );
            // this is the decrypted data as a string
            var decryptedText = decryptedData.toString( CryptoJS.enc.Utf8 );
            var param = decryptedText.split("&");
            var name= param[0].split('=')[1];
            var email = param[1].split('=')[1];

            let ssoModel={name:name, email: email, type:type};
            this.userService.ssoLogin(ssoModel).subscribe((data:LoginData) => {
                console.log(data);

                if (data) {


                    console.log(data);
                    // this.loginData = data;
                    var expireDate = new Date();
                    expireDate.setHours(23, 59, 0, 0);
                    data.user_name = email;
                    this.cookieService.delete('loginSubscriptionData',"/");
                    this.cookieService.set('loginSubscriptionData', JSON.stringify(data), 2345, "/", '', false, 'Lax');
                    const CValue = this.cookieService.get('loginSubscriptionData');
                    this.getUserDetail();
                    //   console.log('Cookie Value>>',CValue);
                    this.cookieService.delete('loginData', '/BeatBlipUI')//Delete The previous user login data.
                    if (this.loginForm.value.remember) {
                        var loginDataToRemember = new User();
                        loginDataToRemember.userName = CryptoJS.AES.encrypt(this.loginForm.value.userName, beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString();
                        loginDataToRemember.password = CryptoJS.AES.encrypt(this.loginForm.value.password, beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString();
                        var expireDate = new Date();
                        expireDate.setHours(23, 59, 0, 0);
                        this.cookieService.set('loginDataToRemember', JSON.stringify(loginDataToRemember), expireDate, "/", '', false, 'Lax');
                    } else {
                        this.cookieService.delete('loginDataToRemember', "/");
                    }
            
                    //this.cookieService.set('loginData',JSON.stringify(data),32,'','.localhost:8080');
                    var hash = window.location.hash
                    var redirect = 'false';
                    if (hash) {
                        var params = hash.split('=');
                        if (params.length > 1) {
                            redirect = params[1];
                        }
                    }
                    if (redirect === 'true') {
                        window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + "/BeatBlipUI"
                    }
                    //  else if(returnUrl)
                    //  {
                    //      this.router.navigate([returnUrl]);
                    //  }
                     else {
                        window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port+"/HuLoopSubscriptionUI/#/Dashboard";

                       // this.router.navigate(['/Dashboard']);
                    }
            
                }
            }, error => {
                // console.log(error);
                // this.toastr.clear();
                // if (error.error && error.error.appStatusCode) {
                //     this.toastr.error(error.error.message);
                // }
            });
              
        }
        if(azureUserName){
           
            // var token = azureToken.split('access_token');
            var azureUsername = azureUserName.substring(1,azureUserName.length-1);
          
           // var email= params[2].substring(0,params[2].indexOf('&'));
            // var type= params[1].substring(1);
            // let returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
            let azureModel={userName:azureUsername,password:'Test@123', remember:false};
            this.userService.login(azureModel).subscribe((data:any) => {
                console.log(data);

                if (data) {


                    console.log(data);
                    // this.loginData = data;
                    var expireDate = new Date();
                    expireDate.setHours(23, 59, 0, 0);
                    data.user_name = email;
                    this.cookieService.delete('loginSubscriptionData',"/");
                    this.cookieService.set('loginSubscriptionData', JSON.stringify(data), 2345, "/", '', false, 'Lax');
                    const CValue = this.cookieService.get('loginSubscriptionData');
                    this.getUserDetail();
                    //   console.log('Cookie Value>>',CValue);
                    this.cookieService.delete('loginData', '/BeatBlipUI')//Delete The previous user login data.
                    if (this.loginForm.value.remember) {
                        var loginDataToRemember = new User();
                        loginDataToRemember.userName = CryptoJS.AES.encrypt(this.loginForm.value.userName, beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString();
                        loginDataToRemember.password = CryptoJS.AES.encrypt(this.loginForm.value.password, beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString();
                        var expireDate = new Date();
                        expireDate.setHours(23, 59, 0, 0);
                        this.cookieService.set('loginDataToRemember', JSON.stringify(loginDataToRemember), expireDate, "/", '', false, 'Lax');
                    } else {
                        this.cookieService.delete('loginDataToRemember', "/");
                    }
            
                    //this.cookieService.set('loginData',JSON.stringify(data),32,'','.localhost:8080');
                    var hash = window.location.hash
                    var redirect = 'false';
                    if (hash) {
                        var params = hash.split('=');
                        if (params.length > 1) {
                            redirect = params[1];
                        }
                    }
                    if (redirect === 'true') {
                        window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + "/BeatBlipUI"
                    }
                    //  else if(returnUrl)
                    //  {
                    //      this.router.navigate([returnUrl]);
                    //  }
                     else {
                        // window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port+"/#/Dashboard";
                        setTimeout(() => {
                            this.router.navigate(["/Dashboard"]);
                          }, 1000);
                    }
            
                }
            }, error => {
                console.log(error);
                this.toastr.clear();
                if (error.error && error.error.appStatusCode) {
                    this.toastr.error(error.error.message);
                }
            });
              
        }
        else if(hash) {
            var params = hash.split('=');
            if(params[0].includes('logout')) {
                logout = params[1];
            } else if(params[0].includes('redirect')){
                redirect = params[1]
            } else if(params[0].includes('differentbrowser')) {
                loggedInFromDifferrntBrowser = params[1];
            } else if(params[0].includes('updatepassword')) {
                updatePassword = params[1];
            } else if(params[0].includes('accesTokenExpired')) {
            	accesTokenExpired = params[1];
            }
            
        }
        if(logout==='true'){
            this.toastr.clear();
            this.toastr.success(beatBlipSubscriptionConsts.LOGOUT_SUCCESSFULLY);
            this.cookieService.delete('loginSubscriptionData',"/");
        }
        if(loggedInFromDifferrntBrowser === 'true') {
            this.toastr.clear();
            this.toastr.error(beatBlipSubscriptionConsts.DIFFERENT_BROWSER_LOGIN);
            this.cookieService.delete('loginSubscriptionData',"/");
        }
        if(updatePassword === 'true') {
            this.toastr.clear();
            this.toastr.success(beatBlipSubscriptionConsts.PASSWORD_CHANGED);
            this.cookieService.delete('loginSubscriptionData',"/");
        }
        if(accesTokenExpired === 'true') {
        	this.toastr.clear();
            this.toastr.error(beatBlipSubscriptionConsts.CUTOMER_TOKEN_EXPIRED);
            this.cookieService.delete('loginSubscriptionData',"/");
        }
        
        if( redirect === 'true') {
        	this.toastr.clear();
            this.cookieService.delete('loginSubscriptionData',"/");
        }

        var userLoginDetails =  this.cookieService.get('loginSubscriptionData');
            if(userLoginDetails) {
                this.router.navigate(['/Dashboard']);
        }
        
        
        this.loginForm = this.formBuilder.group({
            userName: ['', Validators.required],
            password: ['', Validators.required],
            remember: [false]
        });

        var data =  this.cookieService.get('loginDataToRemember');
        if(data) {
            var loginDataToRemember = new User();
            loginDataToRemember =   JSON.parse(data);
            var userName = CryptoJS.AES.decrypt(loginDataToRemember.userName,beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
            var password = CryptoJS.AES.decrypt(loginDataToRemember.password,beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString(CryptoJS.enc.Utf8);
            this.loginForm.controls['userName'].setValue(userName);
            this.loginForm.controls['password'].setValue(password);
            this.loginForm.controls['remember'].setValue(true);
        }

        this.forgotPasswordForm = this.formBuilder.group({
            userName: ['', [Validators.required, Validators.email]],
        });
        
        /*if(this.cookieService.get('loginData')) {
            var loginData = JSON.parse(this.cookieService.get('loginData'));
            var url = "http://localhost:8080/BeatBlipUI/#/home/start?access_token=" + loginData.access_token + "&expires_in="+loginData.expires_in +
            "&token_type"+loginData.token_type + "&refresh_token=" + loginData.refresh_token + "&user_name="+loginData.user_name;
            //window.location.href = this.httpEncode.encodeValue(url);
        }*/

    }
    get f() { return this.loginForm.controls; }

    get forgot() { return this.forgotPasswordForm.controls; }
    headerOptions = {
        showSetting : false,
        showSearch: false,
        heading : '',
        data: undefined,
      }
    getUserDetail(){
        this.userService.getUser().subscribe((data) => {
            this.currentUser = data;
            localStorage.setItem("currentUser", JSON.stringify(data));
            console.log("0000000000000------------0000000000",JSON.parse(localStorage.getItem('currentUser')));
            localStorage.removeItem("selectedProject");
          });
    }
    decrypt(data: string): string {
        const decrypted = CryptoJS.AES.decrypt(data, '12345')
        console.log("Decrypted:" + decrypted);
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    onSubmit() {
        this.submitted = true;
        // stop here if form is invalid
        if (this.loginForm.invalid ) {
            return;
        }
      
        let returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'];
        let row = this.activatedRoute.snapshot.queryParams['row'];
        let task = this.activatedRoute.snapshot.queryParams['task'];
        let instance = this.activatedRoute.snapshot.queryParams['instance'];
        console.log("returnUrl : ", returnUrl);
        this.userService.login(this.loginForm.value).subscribe(
            (data: any) => {
            if (data) {
              
                var expireDate = new Date();
                expireDate.setHours(23, 59, 0, 0);
                data.user_name = this.loginForm.value.userName;
                this.cookieService.set('loginSubscriptionData', JSON.stringify(data), 2345, "/", '', false, 'Lax');
                // this.getUserDetail();
                const CValue = this.cookieService.get('loginSubscriptionData');
                //   console.log('Cookie Value>>',CValue);
                this.cookieService.delete('loginData', '/BeatBlipUI')//Delete The previous user login data.
                if (this.loginForm.value.remember) {
                    var loginDataToRemember = new User();
                    loginDataToRemember.userName = CryptoJS.AES.encrypt(this.loginForm.value.userName, beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString();
                    loginDataToRemember.password = CryptoJS.AES.encrypt(this.loginForm.value.password, beatBlipSubscriptionConsts.ENCRYPTION_KEY).toString();
                    var expireDate = new Date();
                    expireDate.setHours(23, 59, 0, 0);
                    this.cookieService.set('loginDataToRemember', JSON.stringify(loginDataToRemember), expireDate, "/", '', false, 'Lax');
                } else {
                    this.cookieService.delete('loginDataToRemember', "/");
                }
        
                //this.cookieService.set('loginData',JSON.stringify(data),32,'','.localhost:8080');
                var hash = window.location.hash
                var redirect = 'false';
                if (hash) {
                    var params = hash.split('=');
                    if (params.length > 1) {
                        redirect = params[1];
                    }
                }
                if(data.redirectURL){
                    var portalUrl = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port+"/HuLoopSubscriptionUI"
                    var finalUrl = data.redirectURL.replace('http://localhost:9090/duo-callback',portalUrl)
                    window.location.href = finalUrl
                     }
                     else{

                this.userService.getUser().subscribe((data) => {
                  this.currentUser = data;
                  let graphData = JSON.parse(localStorage.getItem('graphData'))
                  if(graphData && graphData.userId != this.currentUser.id)
                  {
                    localStorage.removeItem('graphData');
                  }
                  localStorage.setItem("currentUser", JSON.stringify(data));
                  this.homeService.setHeaderOptions(this.headerOptions);
                  localStorage.removeItem("selectedProject");

                 if (redirect === "true") {
                     window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + "/BeatBlipUI";
                   } 
                   else if (returnUrl && this.isNewUIRedirect === false) {
                    this.checkLoginFlag()
                     this.router.navigate([returnUrl]);
                   }
                   else if(this.isNewUIRedirect === true) {
                    this.checkLoginFlag()
                    //   window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + "/AutomationStudio/#/dashboard";
                   this.router.navigate(["/Dashboard"]);
                   }
                   else {
                     setTimeout(() => {
                       this.checkLoginFlag()
                       this.router.navigate(["/Dashboard"]);
                    //  window.location.href = document.location.protocol + "//" + document.location.hostname + ":" + document.location.port + "/HuLoopSubscriptionUI/#/Dashboard";
                  
                     }, 500);
                  }
                });
                     }
            }
            
        }, error => {
            // this.toastr.clear();
            // if (error.error && error.error.appStatusCode) {
            //     this.toastr.error(error.error.message);
            // }
        });
          
    }

    onSubmitForgotPassword() {
        this.submittedForgotPasswordForm = true;
        if(this.forgotPasswordForm.invalid) {
            return;
        }
       // this.closemodal.nativeElement.click();
        this.userService.forgotPassword(this.forgotPasswordForm.value,this.cancelmodal);
        //return;
    }

    resetForgotPasswordForm() {
        this.submittedForgotPasswordForm = false;
        this.forgotPasswordForm.reset();
    }

    checkLoginFlag(){
        this.userService.getLoginFlag().subscribe(
            (data:any)=>{
                this.allFlag = data['configFlags']
                this.showLogin = this.allFlag.find((f:any)=>f.name=='showLogin').value;
                this.showAzure = this.allFlag.find((f:any)=>f.name=='azureEnabled').value;
                this.showOkta = this.allFlag.find((f:any)=>f.name=='okta').value;
                 this.isNewUIRedirect = true;
                let adoCheck = this.allFlag.find((f:any)=>f.name=='isADOEnabled')?.value;
                localStorage.setItem('isADOEnabled', adoCheck);
                beatBlipSubscriptionConsts.ADOCheck = adoCheck == 'true' ? true : false;
            }
        )
    }
}
